import { type TooltipProps } from "@mantine/core";
import {
  IconInfoCircle,
  type IconProps,
  type TablerIcon
} from "@tabler/icons-react";
import classNames from "classnames";
import { isTooLongText } from "../../utils/isTooLongText";
import "./IconHelpText.scss";
import { IconHelpTextPopover } from "./IconHelpTextPopover";
import { IconHelpTextToolTip } from "./IconHelpTextTooltip";
import { type PopoverPosition } from "./Popover/Popover";

export interface IconHelpTextProps extends Pick<IconProps, "aria-label"> {
  /** Rendered next to the icon as part of the hover/click target */
  children?: React.ReactNode;
  className?: string;
  color?: string;
  helpText: string;
  Icon?: TablerIcon;
  disableMarkdown?: boolean;
  popoverPosition?: PopoverPosition;
  size?: IconProps["size"];
  /** Only applies to short help texts, which render as a tooltip */
  tooltipMaxWidth?: TooltipProps["maw"];
}

function IconHelpText({
  "aria-label": ariaLabel,
  children,
  className,
  color,
  helpText,
  Icon = IconInfoCircle,
  disableMarkdown,
  popoverPosition = "left",
  size,
  tooltipMaxWidth
}: IconHelpTextProps) {
  const combinedClassNames = classNames(
    {
      "help-icon": Icon === IconInfoCircle
    },
    className
  );

  return (
    <>
      {isTooLongText(helpText) ? (
        <IconHelpTextPopover
          aria-label={ariaLabel}
          className={combinedClassNames}
          helpText={helpText}
          Icon={Icon}
          iconColor={color}
          popoverPosition={popoverPosition}
          size={size}
        >
          {children}
        </IconHelpTextPopover>
      ) : (
        <IconHelpTextToolTip
          aria-label={ariaLabel}
          className={combinedClassNames}
          disableMarkdown={disableMarkdown}
          helpText={helpText}
          Icon={Icon}
          iconColor={color}
          maxWidth={tooltipMaxWidth}
          position={popoverPosition}
          size={size}
        >
          {children}
        </IconHelpTextToolTip>
      )}
    </>
  );
}

export { IconHelpText };
